import Model, { executeMutation, GqlError, ID } from 'src/models/model'

export const AUTHORIZED_PURCHASER_ACTIONS = {
  ID: 'id',
  LINK: 'link',
  EMAIL: 'email',
  CARD: 'card',
  TOKEN: 'token',
  IDENTIFY: 'identify'
}

export default class AuthorizedPurchaser extends Model {
  static name = 'AuthorizedPurchaser'

  static define () {
    this.fields = {
      id: {
        type: ID,
        output: true
      },
      purchaserId: {
        type: ID,
        default: null
      },
      purchaseeId: {
        type: ID,
        default: null
      },
      link: {
        type: String,
        default: '',
        output: true
      },
      email: {
        type: String,
        default: '',
        input: true
      },
      cardId: {
        type: String,
        default: '',
        input: true
      },
      lastName: {
        type: String,
        default: '',
        input: true
      },
      purchaserName: {
        type: String,
        output: true
      },
      token: {
        type: String,
        default: '',
        input: true
      },
      action: {
        type: String,
        default: '',
        input: true
      }
    }

    this.mutations = {
      deleteAuthorizedPurchaser: {
        arguments: {
          purchaserId: {
            type: ID,
            required: true
          },
          purchaseeId: {
            type: ID,
            required: true
          }
        },
        results: {
          authorizedPurchaser: AuthorizedPurchaser,
          errors: [GqlError]
        }
      }
    }
  }

  async identify () {
    this.action = AUTHORIZED_PURCHASER_ACTIONS.IDENTIFY

    try {
      const { errors, results } = await this.save()
      return { errors, link: results.link }
    } catch (error) {
      console.log(error)
    } finally {
      this.resetField('action')
    }
  }

  // Arguments are used to self-document required fields,
  // while being optional if the field is already set on this object
  async linkInvite (purchaserId = this.purchaserId) {
    this.purchaserId = purchaserId
    this.action = AUTHORIZED_PURCHASER_ACTIONS.LINK

    try {
      const { errors, results } = await this.save()
      return { errors, link: results.link }
    } catch (error) {
      console.log(error)
    } finally {
      this.resetField('action')
    }
  }

  async emailInvite (purchaserId = this.purchaserId, email = this.email) {
    this.purchaserId = purchaserId
    this.email = email
    this.action = AUTHORIZED_PURCHASER_ACTIONS.EMAIL

    try {
      const { errors } = await this.save()
      return errors
    } catch (error) {
      console.log(error)
    } finally {
      this.resetField('action')
    }
  }

  async addByCard (purchaserId = this.purchaserId, cardId = this.cardId, lastName = this.lastName) {
    this.purchaserId = purchaserId
    this.cardId = cardId
    this.lastName = lastName
    this.action = AUTHORIZED_PURCHASER_ACTIONS.CARD

    try {
      const { errors } = await this.save()
      return errors
    } catch (error) {
      console.log(error)
    } finally {
      this.resetField('action')
    }
  }

  async addByToken (purchaseeId = this.purchaseeId, token = this.token) {
    this.purchaseeId = purchaseeId
    this.token = token
    this.action = AUTHORIZED_PURCHASER_ACTIONS.TOKEN

    try {
      const { errors } = await this.save()
      return errors
    } catch (error) {
      console.log(error)
    } finally {
      this.resetField('action')
    }
  }

  async addById (purchaserId = this.purchaserId, purchaseeId = this.purchaseeId) {
    this.purchaserId = purchaserId
    this.purchaseeId = purchaseeId
    this.action = AUTHORIZED_PURCHASER_ACTIONS.ID

    try {
      const { errors } = await this.save()
      return errors
    } catch (error) {
      console.log(error)
    } finally {
      this.resetField('action')
    }
  }

  async deleteAuthorizedPurchaser (purchaserId = this.purchaserId, purchaseeId = this.purchaseeId) {
    this.purchaserId = purchaserId
    this.purchaseeId = purchaseeId
    const results = await executeMutation(
      'deleteAuthorizedPurchaser',
      {
        purchaserId,
        purchaseeId
      },
      {
        authorizedPurchaser: {
          structure: {
            id: true
          }
        },
        errors: {
          structure: {
            code: true,
            description: true
          }
        }
      }
    )

    return results.errors
  }
}
